export const sidebarDirection = 'left'

export const configInitialValuesBase = {
  Window2InitialValue: null,
  knowledgeTreeMode: 'reference',
  // -----------------------------------------------------------------------------------------------------------
  sidebarCurrent: '1',
  chatMemoConfig: {
    heightOfFieldRatio: 0,
    widthOfField: 1024
  },
  insertConfig: {
    dockVisible: false,
    dockHeight: 0.4,
    sidebarVisible: true
  },
  chatMemoConfigForMemorizing: {
    heightOfFieldRatio: 0,
    widthOfField: 1024
  },
  splitPercentageBetweenQuizAndChatMemo: 60,
  limitNodeHeight: true,
  topRootName: 'My Notes',
  hideSidebar: true,
  // -----------------------------------------------------------------------------------------------------------
  todoListItems: [],
  lastClosedList: [],
  bookmarkIds: [],
  // -----------------------------------------------------------------------------------------------------------
  sharedNodeIds: [],
  // -----------------------------------------------------------------------------------------------------------
  dailyLimit: 0,
  dailyLimitOn: false,
  orderByTree: true,
  nodeTogetherValue: 30,
  wrongNodeDescendants: 'three',
  delayOn: true,
  delayValue: 22,
  ratingConstants: {
    intervalWeightForDown: 0.1,
    difficultyWeightForDown: (5 / 6),
    intervalWeightForUp: 2,
    difficultyWeightForUp: 1,
    failC: 2
  },
  algorithmConstants: {
    easyValue: 1,
    normalValue: 8 / 9,
    hardValue: 0.6
  },
  showMemorizingSetting: false,
  learningTrickBooleans: {
    dontCheckAnswers: false,
    fullScreen: false,
    intermittentReinforcement: {
      active: false,
      sound: true
    },
    obfuscation: false,
    earlyShortBreak: false,
    breakSchedule: {
      active: false,
      mode: '52/17',
      learningTimeFor52: 52,
      learningTimeForPomodoro: 25,
      shortBreakForPomodoro: 5,
      longBreakForPomodoro: 15,
      countForPomodoro: 4
    },
    ambientSound: {
      active: false,
      mode: '1'
    },
    dopamineBoosting: {
      active: false,
      sound: true
    }
  },
  // lastClosedListForPixelMode: JSON.stringify([])
  // -----------------------------------------------------------------------------------------------------------
  chartIds: ['firstOne'],
  nodeIdsOfCharts: { firstOne: [ 'rootNode' ] },
  booleansOfCharts: { firstOne: {
    status: true,
    predictedRatings: true,
    kind: true,
    includeSkippedNotes: false
  }
  },
  memorizeRunRecord: [],
  memorizeCompleteRecord: [],
  totalSynapses: 0,
  // -----------------------------------------------------------------------------------------------------------
  helpSectionOpen: true,
  helpSectionId: 'tour',
  email: '',
  // -----------------------------------------------------------------------------------------------------------
  buttonMode: 'simple',
  // -----------------------------------------------------------------------------------------------------------
  darkMode: false
}

export const configKeysForCloud = Object.keys(configInitialValuesBase)

export const OverlayProps = {
  autoFocus: false,
  boundary: 'viewport',
  enforceFocus: false,
  transitionDuration: 0,
  hoverCloseDelay: 0,
  canEscapeKeyClose: false
}

export const TutorialVideoConfig = {
  containerClassName: 'w-full h-full',
  opts: {
    playerVars: {
      autoPlay: 1,
      cc_load_policy: 1,
      cc_lang_pref: 'en'
    },
    width: '100%',
    height: '100%'
  }
}

export const decoratingConfig = {
  bold: {
    name: 'bold',
    icon: 'bold',
    text: 'Bold',
    key: 'mod + b'
  },
  italic: {
    name: 'italic',
    icon: 'italic',
    text: 'Italic',
    key: 'mod + i'
  },
  underline: {
    name: 'underline',
    icon: 'underline',
    text: 'Underline',
    key: 'mod + u'
  },
  strike: {
    name: 'strike',
    icon: 'strikeThrough',
    text: 'Strike Through',
    key: 'mod + s'
  },
  highlight: {
    name: 'highlight',
    icon: 'highlight',
    text: 'Highlight',
    key: 'mod + shift + l',
    options:
  [
    {
      number: 1,
      color: 'var(--highlightColor1)',
      buttonColor: 'var(--highlightColorThick1)'
    },
    {
      number: 2,
      color: 'var(--highlightColor2)',
      buttonColor: 'var(--highlightColorThick2)'
    },
    {
      number: 3,
      color: 'var(--highlightColor3)',
      buttonColor: 'var(--highlightColorThick3)'
    },
    {
      number: 4,
      color: 'var(--highlightColor4)',
      buttonColor: 'var(--highlightColorThick4)'
    },
    {
      number: 5,
      color: 'var(--highlightColor5)',
      buttonColor: 'var(--highlightColorThick5)'
    },
    {
      number: 6,
      color: 'var(--highlightColor6)',
      buttonColor: 'var(--highlightColorThick6)'
    }
  ],
    lastOptionNumber:
  6
  },
  boxHighlight: {
    name: 'boxHighlight',
    icon: 'annotation',
    text: 'Box Highlight',
    key: 'mod + shift + b',
    options: [
      {
        number: 1,
        color: 'var(--highlightColor1)',
        buttonColor: 'var(--highlightColorThick1)'
      },
      {
        number: 2,
        color: 'var(--highlightColor2)',
        buttonColor: 'var(--highlightColorThick2)'
      },
      {
        number: 3,
        color: 'var(--highlightColor3)',
        buttonColor: 'var(--highlightColorThick3)'
      },
      {
        number: 4,
        color: 'var(--highlightColor4)',
        buttonColor: 'var(--highlightColorThick4)'
      },
      {
        number: 5,
        color: 'var(--highlightColor5)',
        buttonColor: 'var(--highlightColorThick5)'
      },
      {
        number: 6,
        color: 'var(--highlightColor6)',
        buttonColor: 'var(--highlightColorThick6)'
      }
    ],
    lastOptionNumber: 6
  },
  numberedList: {
    name: 'numberedList',
    icon: 'numbered-list',
    text: 'Numbered List',
    key: 'mod + shift + n'
  },
  heading: {
    name: 'heading',
    icon: 'header',
    text: 'Heading',
    key: 'mod + shift + h',
    options: [
      {
        number: 1,
        icon: 'header-one'
      },
      {
        number: 2,
        icon: 'header-two'
      }
    ],
    lastOptionNumber: 2
  }
}
